export default __webpack_public_path__ + "static/media/go_above_and_beyond.af7fbefb.png";